import type { ReactNode } from 'react';
import { cn } from './utils';

/**
 * Page-grammar primitive (SIL-538, W0 of
 * resources/plans/wayfinder-ux-consistency-spec.md §1.1-1.2): the heading a
 * `Card` panel opens with — title, optional one-line description, optional
 * right-aligned slot (an action button, a `StatusPill`, a link). Mirrors
 * `PageHeader`'s two-line shape one level down, at the Title type step
 * (DESIGN.md Typography) rather than Headline.
 */
export function PanelTitle({
  title,
  description,
  right,
  className,
}: {
  title: string;
  description?: string;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-start justify-between gap-3', className)}>
      <div className="min-w-0">
        <h2 className="text-[15px] font-semibold text-foreground">{title}</h2>
        {description && <p className="mt-0.5 text-xs text-muted-foreground">{description}</p>}
      </div>
      {right && <div className="flex shrink-0 items-center gap-2">{right}</div>}
    </div>
  );
}
